/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  getFuelCodeInfo,
  postFuelCodeInfo,
  deleteFuelCodeInfo,
} from 'api/pgads.js'
import { Input, Button, InputNumber } from 'antd'

import CommonScreen from './CommonScreen'

const headers = [
  strCol({ ident: 'code', display: 'Code', isKey: true, width: 70 }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 150,
  }),
  strCol({
    ident: 'unit99',
    display: 'Card99 Quantity',
  }),
  strCol({
    ident: 'unitGui',
    display: 'GUI Quantity',
  }),
  numCol({
    ident: 'conversion',
    display: 'Quantity Conversion',
    width: 150,
  }),
  strCol({
    ident: 'heatUnit99',
    display: 'Card99 Heat Rate',
    width: 110,
  }),
  strCol({
    ident: 'heatUnitGui',
    display: 'GUI Heat Rate',
  }),
  numCol({
    ident: 'heatConversion',
    display: 'Heat Rate Conversion',
    width: 130,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getFuelCodeInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postFuelCodeInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteFuelCodeInfo(apiTargetInfo)(data)

const title = 'Fuel Code Management'

// const defaultData = {}

const FuelCodeMgmt = () => {
  const [insertEvent, setInsertEvent] = useState(false)
  // const [] = useState(defaultData)
  // const [] = useState(null)

  // const setData = data => {
  //   setInsertData({ ...insertData, ...data })
  // }
  // const onCancel = () => {
  //   setInsertEvent(false)
  // }
  // // const validateData = () => {
  // //   const { company, year, holidayDate } = insertData
  // //   if (company === undefined) message.error('Please, Select Company to Save')
  // //   else if (year === undefined) message.error('Please, Insert Year to Save')
  // //   else if (holidayDate === undefined) message.error('Please, Select Holiday Date to Save')
  // //   else return true
  // //   return false
  // // }

  // const onAdd = ({ hide, retrieve }) => {
  //   if (insertData.code === undefined || insertData.code.trim().length == 0) {
  //     message.error('Please, Insert Code before Save')
  //     return
  //   }
  //   modifyTask(apiTargetInfo)([insertData]).fork(setErr, _ => {
  //     message.info('Data Saved')
  //     setInsertEvent(!hide)
  //     setInsertData(defaultData)
  //     retrieve && retrieve()
  //   })
  // }
  // useEffect(() => {
  //   setInsertData(defaultData)
  // }, [insertEvent])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '10px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <td style={{ textAlign: 'right' }}>Code : </td>
            <td>
              <Input
                placeholder="Code"
                value={insertData.code}
                onChange={e =>
                  setInsertData({ ...insertData, code: e.target.value })
                }
                maxLength={2}
              />
            </td>
            <td style={{ textAlign: 'right' }}>Description : </td>
            <td colSpan={3}>
              <Input
                placeholder="Description"
                value={insertData.description}
                onChange={e =>
                  setInsertData({ ...insertData, description: e.target.value })
                }
              />
            </td>
          </tr>
          <tr>
            <td style={{ textAlign: 'right' }}>Card99 Quantity : </td>
            <td>
              <Input
                placeholder="Card99 Quantity"
                value={insertData.unit99}
                onChange={e =>
                  setInsertData({ ...insertData, unit99: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>GUI Quantity : </td>
            <td>
              <Input
                placeholder="GUI Quantity"
                value={insertData.unitGui}
                onChange={e =>
                  setInsertData({ ...insertData, unitGui: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Quantity Conversion : </td>
            <td>
              <InputNumber
                placeholder="Quantity Conversion"
                value={insertData.conversion}
                onChange={value =>
                  setInsertData({ ...insertData, conversion: value })
                }
              />
            </td>
            <td />
          </tr>
          <tr>
            <td style={{ textAlign: 'right' }}>Card99 Heat Rate : </td>
            <td>
              <Input
                placeholder="C99 Heat Rate"
                value={insertData.heatUnit99}
                onChange={e =>
                  setInsertData({ ...insertData, heatUnit99: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>GUI Heat Rate : </td>
            <td>
              <Input
                placeholder="GUI Heat Rate"
                value={insertData.heatUnitGui}
                onChange={e =>
                  setInsertData({ ...insertData, heatUnitGui: e.target.value })
                }
              />
            </td>
            <td style={{ textAlign: 'right' }}>Heat Rate Conversion : </td>
            <td>
              <InputNumber
                placeholder="HR Conversion"
                value={insertData.heatConversion}
                onChange={value =>
                  setInsertData({ ...insertData, heatConversion: value })
                }
              />
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.description}
      autoRetrieve
      sortOptions={[
        { ident: 'description', display: 'Description', sortOrder: 'asc' },
      ]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(FuelCodeMgmt)
